module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-analysis-data-table')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1dc2724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/StatisticsAnalysis/index.vue
// module id = 2257
// module chunks = 0